import { createStore, combineReducers, applyMiddleware, compose } from 'redux'
import createDebounce from 'redux-debounced'
import thunk from 'redux-thunk'
import { createLogger } from 'redux-logger'
import api from './middleware/api'
import reducers from '../reducers'
import preloadedState from './preloaded-state'

export default function configureStore(apollo) {
  const store = createStore(
    combineReducers({
      ...reducers
    }),
    preloadedState,
    compose(
      // middleware
      applyMiddleware(...middleware()),
      // devtools
      window.devToolsExtension ? window.devToolsExtension() : f => f
    )
  )

  return store
}

function middleware() {
  const middleware = [thunk, createDebounce(), api]
  if (process.env.NODE_ENV === 'development') {
    // support disabling the logger (@Rowno hates it)
    if (window.localStorage.reduxlogger !== 'false') {
      middleware.push(createLogger({ collapsed: true }))
    }
  }
  return middleware
}
